export class Item {
  public constructor(
    public id: string,
    public name: string
  ) {}
}
